import { actionTypes } from './constants';
import { actionTypes as operationalParamActions } from '../../constants';
import { AnalyticsApi } from 'api';
import { apiCallStatus } from 'helpers/constants';
import { getApiActionCreator } from 'helpers/actionHelper';
import { getAssetTypeId } from 'helpers/assetAndPowertrainFilterHelper';
import { createParamMeasurementAssetObjV2 } from '../../../../../PowertrainAssetDetails/helpers';
import { histoScatterDateFormat } from '../../OperationalParametersHeader/constants';
import moment from 'moment';

const histogramKpiAction = getApiActionCreator(actionTypes.GET_ASSET_HISTOGRAM_KPIS_V2);
export const getHistogramKPIsForAsset = (assetObj) => {
    return (dispatch) => {
        dispatch(histogramKpiAction(apiCallStatus.LOADING));
        AnalyticsApi.getHistogramV2Config(assetObj?.id)
            .then((data) => {
                dispatch(histogramKpiAction(apiCallStatus.SUCCESS, data?.histograms));
            })
            .catch((err) => {
                dispatch(histogramKpiAction(apiCallStatus.ERROR, null, err));
            });
    };
};


const histogramDataAction = getApiActionCreator(actionTypes.GET_HISTOGRAM_V2);
export const getHistogramForAsset = (from, to, assetObj, measurement) => {
    return (dispatch, getState) => {
        // Create parameter object for POST body content
        const param = createParamMeasurementAssetObjV2(measurement, assetObj);
        const originalAssetID = getState().powertrainAssetDetails?.selectedAsset?.id;
        from = moment(from).format(histoScatterDateFormat);
        to = moment(to).format(histoScatterDateFormat);

        dispatch(histogramDataAction(apiCallStatus.LOADING));

        AnalyticsApi.getHistogramV2Data(param, from, to)
            .then((data) => {
                const assetID = getState().powertrainAssetDetails?.selectedAsset?.id;

                if (originalAssetID === assetID) {
                    dispatch(histogramDataAction(apiCallStatus.SUCCESS, data));
                }
            })
            .catch((err) => {
                dispatch(histogramDataAction(apiCallStatus.ERROR, null, err));
            });
    };
};

export const setSelectedDates = (from, to) => {
    return (dispatch) => {
        dispatch({ type: operationalParamActions.SET_DATE_SELECTION, dateSelection: { from, to } });
    };
};

export const setSelectedKpi = (histogramSelectedKpi) => {
    return (dispatch, getState) => {
        const asset = getState()?.powertrainAssetDetails?.selectedAsset;
        dispatch({
            type: actionTypes.SET_HISTOGRAM_KPI_V2,
            histogramSelectedKpi: {
                ...histogramSelectedKpi,
                assetTypeID: getAssetTypeId(asset?.assetType)
            }
        });
    };
};

const removeSelectedKpiLegendAction = (signalIndex) => {
    return {
        type: actionTypes.REMOVE_TREND_KPI_SELECTION_LEGEND_HISTOGRAM_V2,
        signalIndex
    };
};

// Action Creators
export const removeSelectedKpiLegend = (signalIndex) => {
    return (dispatch) => {
        dispatch(removeSelectedKpiLegendAction(signalIndex));
    };
};
